import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import naturaljaggery from "../../../public/naturaljaggery.jpeg";
import originicjaggery from "../../../public/1.jpeg";
import jaggerypowder from "../../../public/powder.jpg";
import jaggerycubes from "../../../public/originicjaggery.jpeg";
const products = [
  {
    id: 1,
    name: 'Organic Jaggery',
    description: 'Traditional natural sweetener made from pure sugarcane juice.',
    image: naturaljaggery,
  },
  {
    id: 2,
    name: 'Natural Jaggery',
    description: 'Unrefined healthy alternative to refined sugar.',
    
        image: originicjaggery,
  },
  {
    id: 3,
    name: 'Jaggery Powder',
    description: 'Fine powdered jaggery used in cooking and food processing.',
    image: jaggerypowder,
  },
  {
    id: 4,
    name: 'Jaggery Cubes',
    description: 'Small jaggery cubes ideal for tea, beverages and snacks.',
    image: jaggerycubes,
  },
];

export default function Products() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(0);
  const navigate = useNavigate();

  const getProductRoute = (productId: number) => {
    switch (productId) {
      case 1:
        return "/products/organic-jaggery";
      case 2:
        return "/products/natural-jaggery";
      case 3:
        return "/products/powder";
      case 4:
        return "/products/cube";
      default:
        return "/#products";
    }
  };

  return (
    <section id="products" className="py-16 md:py-24 bg-[#F8F9FA]">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="text-4xl md:text-5xl font-bold text-center text-[#1A365D] mb-12 md:mb-16">
          Our Products
        </h2>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5 h-[700px] md:h-[800px] lg:h-[600px] items-stretch">
          {products.map((product, index) => (
            <div
              key={product.id}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              onClick={() => {
                setHoveredIndex(index);
                navigate(getProductRoute(product.id));
              }}
              className={`relative rounded-3xl overflow-hidden cursor-pointer transition-all duration-700 ease-in-out ${hoveredIndex === index ? 'flex-[4]' : 'flex-[1]'
                }`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700"
                style={{
                  backgroundImage: `url(${product.image})`,
                  transform: hoveredIndex === index ? 'scale(1.05)' : 'scale(1)'
                }}
              >
                <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent transition-opacity duration-500 ${hoveredIndex === index ? 'opacity-100' : 'opacity-70'
                  }`}></div>
              </div>

              <div className="relative h-full flex flex-col justify-end p-6 md:p-8">
                <h3 className={`font-bold text-white mb-2 transition-all duration-500 ${hoveredIndex === index ? 'text-2xl md:text-3xl' : 'text-lg md:text-xl'
                  }`}>
                  {product.name}
                </h3>
                <div className={`overflow-hidden transition-all duration-500 ease-in-out ${hoveredIndex === index ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'
                  }`}>
                  <p className="text-white/90 text-sm md:text-base mb-4">
                    {product.description}
                  </p>
                  <div className="flex items-center text-white font-medium cursor-pointer hover:text-[#4A90E2] transition-colors group">
                    Learn More <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}